import http from "./http";

// function getVehicleNoList(data) {
//   return http.post(`vehicleListforRoutes`, data);
// }

function getVehicleNoList(data) {
  return http.post(`District_wiseVehicleList_new`, data);
}

function getRouteList(data) {
  return http.post(`Vtsroutes_List`, data);
}

function saveAllotmentData(data) {
  return http.post(`vehicle_to_Routes`, data);
}

const RouteAllotmentService = {
  getVehicleNoList,
  getRouteList,
  saveAllotmentData,
};

export default RouteAllotmentService;
